jQuery( function ( $ ) {

  $( '.woocommerce-form.login button.toggle-reg' ).on( 'click', function () {
    const $login_form = $(this).closest( '.woocommerce-form.login' );
    const $reg_form = $login_form.next( '.woocommerce-form.register' );
    if ( $reg_form.length ) {
      $login_form.hide();
      $reg_form.show();
      $reg_form.trigger( 'wc-reg-form-enabled', true );
    }
  });


  $( '.woocommerce-form.register button.toggle-login' ).on( 'click', function () {
    const $reg_form = $(this).closest( '.woocommerce-form.register' );
    const $login_form = $reg_form.prev( '.woocommerce-form.login' );
    if ( $login_form.length ) {
      $login_form.show();
      $reg_form.hide();
      $reg_form.trigger( 'wc-reg-form-enabled', false );
    }
  });

});